import './style.scss';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ja from 'date-fns/locale/ja';
import { FormError } from '../formErrorScroll';
registerLocale('ja', ja);

export type DateInputProps = {
  date: Date | null | undefined;
  name?: string;
  openToDate?: Date | undefined;
  minDate?: Date | null;
  maxDate?: Date | null;
  onChange?: (value: Date | null) => void;
  onBlur?: (e: React.FocusEvent<any, Element>) => void;
  isWeekEndDisable?: boolean;
  title?: string;
  placeholder?: string;
  showYearMonthDropdown?: boolean;
  error?: string;
};

export const DateInput = ({
  date,
  name,
  openToDate,
  minDate,
  maxDate,
  onChange,
  onBlur,
  isWeekEndDisable,
  title,
  placeholder = '選択してください',
  showYearMonthDropdown,
  error,
}: DateInputProps) => {
  return (
    <div className="dateInputWrapper">
      <div className="dateInput">
        {title && <span>{title}</span>}
        <DatePicker
          selected={date}
          placeholderText={placeholder}
          name={name}
          onChange={(date) => onChange?.(date)}
          onBlur={onBlur}
          filterDate={(date) => {
            if (isWeekEndDisable) {
              const day = date.getDay();
              return day !== 0 && day !== 6;
            } else {
              return true;
            }
          }}
          openToDate={openToDate}
          minDate={minDate}
          maxDate={maxDate}
          locale="ja"
          dateFormatCalendar="yyyy年 MM月"
          dateFormat="yyyy/MM/dd"
          showMonthDropdown={showYearMonthDropdown}
          showYearDropdown={showYearMonthDropdown}
          dropdownMode="select"
          autoComplete="off"
        />
      </div>
      <FormError className="dateInputWrapper_error" error={error} />
    </div>
  );
};

export const UnderlineDateInput = ({
  date,
  name,
  minDate,
  maxDate,
  onChange,
  onBlur,
  isWeekEndDisable,
  title,
  placeholder = '日付を選択',
  showYearMonthDropdown,
  error,
}: DateInputProps) => {
  return (
    <div className="dateInputWrapper">
      <div className="underlineDateInput">
        {title && <span>{title}</span>}
        <DatePicker
          className='underline-datepicker'
          selected={date}
          placeholderText={placeholder}
          name={name}
          onChange={(date) => onChange?.(date)}
          onBlur={onBlur}
          filterDate={(date) => {
            if (isWeekEndDisable) {
              const day = date.getDay();
              return day !== 0 && day !== 6;
            } else {
              return true;
            }
          }}
          minDate={minDate}
          maxDate={maxDate}
          locale="ja"
          dateFormatCalendar="yyyy年 MM月"
          dateFormat="yyyy/MM/dd"
          showMonthDropdown={showYearMonthDropdown}
          showYearDropdown={showYearMonthDropdown}
          dropdownMode="select"
          autoComplete="off"
        />
      </div>
      <FormError className="dateInputWrapper_error" error={error} />
    </div>
  );
};